(() => {
  if (customElements.get('stock-alert-modal')) return;

  class StockAlertModal extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector('[data-stock-alert-form]');
      this.submitButton = this.querySelector('[data-stock-alert-submit]');
      this.status = this.querySelector('[data-stock-alert-status]');
      this.fields = this.querySelector('[data-stock-alert-fields]');
      this.bellIcon = this.querySelector('[data-stock-alert-bell]');
      this.checkIcon = this.querySelector('[data-stock-alert-check]');

      this.listeners?.abort();
      this.cancelRequest();

      if (!this.form || !this.submitButton || !this.status || !this.fields) {
        this.hidden = true;
        console.error('Stock alert: gerekli HTML alanları bulunamadı.');
        return;
      }

      this.listeners = new AbortController();
      this.savedRequests = this.savedRequests || new Set();
      this.optionNames = this.readArray(this.dataset.optionNames);

      if (!this.initialized) {
        this.variant =
          this.dataset.soldOut === 'true' && this.dataset.variantId
            ? {
                id: this.dataset.variantId,
                title: this.dataset.variantTitle,
                options: this.readArray(this.dataset.variantOptions),
                available: false
              }
            : null;

        this.initialized = true;
      }

      this.hidden = !this.variant;
      this.resetForm();
      this.syncWishlist();

      if (this.variant && this.savedRequests.has(this.requestKey())) {
        this.showSuccess();
      }

      this.form.addEventListener(
        'submit',
        (event) => {
          event.preventDefault();
          this.subscribe();
        },
        { signal: this.listeners.signal }
      );
    }

    disconnectedCallback() {
      this.cancelRequest();
      this.listeners?.abort();
    }

    text(key) {
      const fallback = {
        labelTitle: 'Notify me when available',
        labelSubmit: 'Notify me',
        labelSaving: 'Saving…',
        messageSuccess:
          'Your request has been saved. We will email you when your selected option is back in stock.',
        messageDuplicate:
          'You have already requested a notification for this option.',
        messageError:
          'We could not confirm your request. Please try again.',
        messageUnavailable:
          'Notifications are temporarily unavailable. Please try again later.',
        messageInvalidEmail:
          'Please enter a valid email address.'
      };

      return this.dataset[key] || fallback[key] || '';
    }

    readArray(json) {
      try {
        const parsed = JSON.parse(json || '[]');
        return Array.isArray(parsed) ? parsed : [];
      } catch (_) {
        return [];
      }
    }

    variantOptions() {
      const values = Array.isArray(this.variant?.options)
        ? this.variant.options
        : (this.optionNames || []).map(
            (_, index) => this.variant?.[`option${index + 1}`]
          );

      return values.map((value) =>
        String(
          value && typeof value === 'object'
            ? (value.value ?? value.name ?? '')
            : (value ?? '')
        )
      );
    }

    setVariant(variant) {
      const next =
        variant?.id && variant.available === false ? variant : null;

      const changed =
        String(next?.id || '') !== String(this.variant?.id || '');

      if (changed) {
        this.cancelRequest();
      }

      this.variant = next;
      this.hidden = !next;
      this.syncWishlist();

      if (!this.form || !this.fields || !this.submitButton) return;

      if (changed) {
        this.resetForm();

        if (next && this.savedRequests?.has(this.requestKey())) {
          this.showSuccess();
        }
      }
    }

    open() {
      if (!this.variant?.id || !this.form) return;

      this.hidden = false;

      if (this.completed) return;

      (
        this.form.querySelector('input[type="email"]') ||
        this.submitButton
      )?.focus();
    }
    syncWishlist() {
  const wrapper = this.closest('.product-form');

  if (!wrapper || !this.form || !this.submitButton) return;

  if (!this.wishlistButton) {
    this.wishlistButton = wrapper.querySelector(
      '.product-purchase-actions__wishlist'
    );

    if (!this.wishlistButton) return;

    this.wishlistPlaceholder = document.createComment(
      'wishlist-original-position'
    );

    this.wishlistButton.before(this.wishlistPlaceholder);
  }

  if (this.variant?.id && this.variant.available === false) {
    this.submitButton.after(this.wishlistButton);
    this.form.classList.add('stock-alert__form--with-wishlist');
  } else {
    if (this.wishlistPlaceholder?.parentNode) {
      this.wishlistPlaceholder.after(this.wishlistButton);
    }

    this.form.classList.remove('stock-alert__form--with-wishlist');
  }
}

    requestKey() {
      const emailInput = this.form?.elements.namedItem('email');

      return JSON.stringify([
        String(this.variant?.id || ''),
        String(emailInput?.value || '').trim().toLowerCase()
      ]);
    }

    resetForm() {
      if (!this.form || !this.fields || !this.submitButton) return;

      this.completed = false;
      this.form.hidden = false;
      this.fields.hidden = false;

      this.status.hidden = true;
      this.status.textContent = '';
      delete this.status.dataset.state;

      this.submitButton.classList.remove('is-success');

      if (this.bellIcon) this.bellIcon.hidden = false;
      if (this.checkIcon) this.checkIcon.hidden = true;

      this.setBusy(false);
    }

    setBusy(busy) {
      this.busy = busy;

      if (!this.form || !this.submitButton) return;

      this.submitButton.disabled = busy || Boolean(this.completed);
      this.form.setAttribute('aria-busy', String(busy));

      const emailInput = this.form.elements.namedItem('email');

      if (emailInput?.type === 'email') {
        emailInput.readOnly = busy;
      }

      const label = this.submitButton.querySelector('span');

      if (label) {
        label.textContent = this.completed
          ? this.submitButton.dataset.doneLabel || this.text('messageSuccess')
          : busy
            ? this.text('labelSaving')
            : this.submitButton.dataset.idleLabel || this.text('labelSubmit');
      }
    }

    showSuccess() {
      this.completed = true;
      this.form.hidden = false;
      this.fields.hidden = true;

      this.submitButton.classList.add('is-success');

      if (this.bellIcon) this.bellIcon.hidden = true;
      if (this.checkIcon) this.checkIcon.hidden = false;

      this.setBusy(false);

      this.showStatus(
        this.submitButton.dataset.continueLabel || this.text('messageSuccess'),
        'success'
      );
    }

    showStatus(message, state) {
      this.status.textContent = message;
      this.status.dataset.state = state;
      this.status.hidden = false;
    }

    cancelRequest() {
      this.request?.abort();
      this.request = null;

      if (this.requestTimeout) {
        clearTimeout(this.requestTimeout);
        this.requestTimeout = null;
      }
    }

    buildPayload() {
      const names = this.optionNames || [];
      const values = this.variantOptions();
      const namedOptions = Object.create(null);

      names.forEach((name, index) => {
        namedOptions[String(name)] = values[index] || '';
      });

      const normalizeName = (name) =>
        String(name)
          .trim()
          .normalize('NFKD')
          .replace(/[\u0300-\u036f]/g, '')
          .toLowerCase()
          .replace(/ı/g, 'i');

      const normalizedNames = names.map(normalizeName);

      const findOption = (aliases) => {
        const normalizedAliases = aliases.map(normalizeName);

        const index = normalizedNames.findIndex((name) =>
          normalizedAliases.includes(name)
        );

        return index === -1 ? '' : (values[index] || '');
      };

      const productUrl = new URL(
        this.dataset.productUrl,
        window.location.origin
      );

      productUrl.searchParams.set('variant', String(this.variant.id));

      const title = this.variant.title || values.join(' / ');
      const emailInput = this.form.elements.namedItem('email');

      return new URLSearchParams({
        customer_id: this.dataset.customerId || '0',
        eposta: emailInput.value.trim(),
        product_id: String(this.dataset.productId),
        product_name: this.dataset.productName || '',
        variant_id: String(this.variant.id),
        variant_name: title === 'Default Title' ? '' : title,
        urun_linki: productUrl.href,

        renk: findOption([
          'renk',
          'color',
          'colour',
          'اللون',
          'لون',
          'цвет'
        ]),

        beden: findOption([
          'beden',
          'numara',
          'size',
          'ayakkabı numarası',
          'المقاس',
          'مقاس',
          'الحجم',
          'حجم',
          'размер'
        ]),

        secenekler: JSON.stringify(namedOptions),
        language: this.dataset.language || 'en'
      });
    }

    async subscribe() {
      if (this.busy || this.completed || !this.variant?.id) return;

      const emailInput = this.form.elements.namedItem('email');

      if (!emailInput) {
        this.showStatus(this.text('messageUnavailable'), 'error');
        return;
      }

      const email = emailInput.value.trim();
      emailInput.value = email;

      const invalidEmail =
        !email ||
        email.length > 254 ||
        !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

      if (
        invalidEmail ||
        (emailInput.type === 'email' && !emailInput.checkValidity())
      ) {
        this.showStatus(this.text('messageInvalidEmail'), 'error');

        if (emailInput.type !== 'hidden') {
          emailInput.focus();
        }

        return;
      }

      const configuredEndpoint = this.dataset.endpoint?.trim();

      let endpoint;
      let payload;

      try {
        if (!configuredEndpoint) {
          throw new Error('Endpoint not configured');
        }

        endpoint = new URL(
          configuredEndpoint,
          window.location.origin
        );

        if (
          endpoint.protocol !== 'https:' &&
          endpoint.origin !== window.location.origin
        ) {
          throw new Error('HTTPS endpoint required');
        }

        payload = this.buildPayload();
      } catch (_) {
        this.showStatus(this.text('messageUnavailable'), 'error');
        return;
      }

      const requestKey = this.requestKey();

      if (this.savedRequests.has(requestKey)) {
        this.showSuccess();
        return;
      }

      const request = new AbortController();
      this.request = request;

      const timeout = setTimeout(() => request.abort(), 15000);
      this.requestTimeout = timeout;

      this.status.hidden = true;
      this.setBusy(true);

      try {
        const response = await fetch(endpoint.href, {
          method: 'POST',

          credentials:
            endpoint.origin === window.location.origin
              ? 'same-origin'
              : 'omit',

          headers: {
            'Content-Type':
              'application/x-www-form-urlencoded;charset=UTF-8',
            Accept: 'application/json'
          },

          body: payload.toString(),
          signal: request.signal
        });

        const result = await response.json();

        if (this.request !== request || !this.isConnected) return;

        const alreadyRecorded =
          result?.success === false &&
          result?.code === 'already_recorded';

        if (
          alreadyRecorded &&
          (response.ok || response.status === 409)
        ) {
          this.savedRequests.add(requestKey);
          this.showSuccess();
          return;
        }

        if (!response.ok || result?.success !== true) {
          this.showStatus(
            this.text(
              result?.code === 'invalid_email'
                ? 'messageInvalidEmail'
                : 'messageError'
            ),
            'error'
          );

          return;
        }

        this.savedRequests.add(requestKey);
        this.showSuccess();
      } catch (_) {
        if (this.request !== request || !this.isConnected) return;

        this.showStatus(this.text('messageError'), 'error');
      } finally {
        clearTimeout(timeout);

        if (this.request === request) {
          this.request = null;
          this.requestTimeout = null;
          this.setBusy(false);
        }
      }
    }
  }

  customElements.define('stock-alert-modal', StockAlertModal);

  document.addEventListener('click', (event) => {
    const trigger = event.target.closest?.(
      '[data-stock-alert-trigger]'
    );

    if (!trigger || trigger.hidden) return;

    event.preventDefault();

    trigger
      .closest('.product-form')
      ?.querySelector('stock-alert-modal')
      ?.open();
  });
})();